import { useState } from 'react';

import { TruncatedText } from '@vlabs/shared/components/truncated-text/TruncatedText';
import { Link } from '@vlabs/uikit/components/controls/link/Link';

import { useGetDepartments } from '@vlabs/api/artemy/client';
import type { DepartmentId } from '@vlabs/api/artemy/model';

import st from './shared.module.sass';
import { useUserListTableViewerTranslation } from '../../i18n';

interface DepartmentsCellProps {
  departmentIds?: DepartmentId[];
}

function DepartmentsCell({
  departmentIds = [],
}: DepartmentsCellProps): React.JSX.Element | null {
  const { t } = useUserListTableViewerTranslation();
  const [showAll, setShowAll] = useState(false);

  const visibleDepartmentIds = showAll ? departmentIds : departmentIds.slice(0, 2);
  const hiddenCount = departmentIds.length - visibleDepartmentIds.length;

  const { data } = useGetDepartments(
    { department_ids: visibleDepartmentIds },
    { query: { enabled: visibleDepartmentIds.length > 0 } },
  );

  if (!departmentIds.length || !data?.departments?.length) {
    return null;
  }

  return (
    <div className={st.Departments}>
      {data.departments.map((department) => {
        const departmentName = department.name ?? department.department_id;
        return (
          <span
            className={st.Department}
            key={department.department_id}
          >
            <TruncatedText
              hasTruncation
              tooltipContent={departmentName}
            >
              {departmentName}
            </TruncatedText>
          </span>
        );
      })}
      {hiddenCount > 0 && (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <Link
          as="button"
          className={st.MoreDepartments}
          kind="primary"
          onClick={() => setShowAll(true)}
          size="medium"
          type="button"
        >
          {t('departments.more', { count: hiddenCount })}
        </Link>
      )}
    </div>
  );
}

export { DepartmentsCell };
